import React from 'react';
import { dsnCN } from "../../hooks/helper";

function AddressFooter({ className, ...restProps }) {
    return (
        <div className={dsnCN('col-address', className)} {...restProps}>
            <a href='/map'>
                Along the river that flows backward, <br /> where wind chimes ring <br /> though no wind blows
            </a>
        </div>
    );
}

export default AddressFooter;